import React, { useRef, useEffect, useState } from "react";

const CircularWavePattern = ({ audioElement, showVideo }) => {
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const rafIdRef = useRef(null);
  const [volume, setVolume] = useState(0);

  let track = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const center = { x: canvas.width / 2, y: canvas.height / 2 };

    const drawWaveCircle = (volume) => {
      const radius = 55; // Base radius of the circle
      const amplitude = volume / 2; // Adjust amplitude based on volume

      context.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas
      context.beginPath();
      context.lineWidth = 3; // Line thickness
      context.shadowBlur = 15; // Shadow/Glow blur
      context.shadowColor = "#CDCBFF"; // Shadow/Glow color

      for (let angle = 0; angle <= Math.PI * 2; angle += 0.01) {
        let waveAmplitude = amplitude * Math.sin(angle * 10); // Wave frequency
        let x = center.x + (radius + waveAmplitude) * Math.cos(angle);
        let y = center.y + (radius + waveAmplitude) * Math.sin(angle);

        if (angle === 0) {
          context.moveTo(x, y);
        } else {
          context.lineTo(x, y);
        }
      }
      context.closePath();
      context.strokeStyle = "#CDCBFF";
      context.stroke();
    };

    const calculateVolume = () => {
      analyserRef.current.getByteFrequencyData(dataArrayRef.current);
      const sum = dataArrayRef.current.reduce((acc, val) => acc + val, 0);
      const averageVolume = sum / dataArrayRef.current.length;
      setVolume(averageVolume);
      drawWaveCircle(averageVolume);
      rafIdRef.current = requestAnimationFrame(calculateVolume);
    };

    const initializeAudioContext = () => {
      if (audioElement && !audioContextRef.current) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        audioContextRef.current = new AudioContext();
        track.current =
          audioContextRef.current.createMediaElementSource(audioElement);
        analyserRef.current = audioContextRef.current.createAnalyser();
        analyserRef.current.fftSize = 256;
        dataArrayRef.current = new Uint8Array(
          analyserRef.current.frequencyBinCount
        );
        track.current.connect(analyserRef.current);
        analyserRef.current.connect(audioContextRef.current.destination);
        rafIdRef.current = requestAnimationFrame(calculateVolume);
      }
    };

    // Initialize the audio context
    if (showVideo) {
      initializeAudioContext();
    }

    return () => {
      // Cleanup function to disconnect and close audio context
      cancelAnimationFrame(rafIdRef.current);

      if (audioContextRef.current) {
        if (track.current) track.current.disconnect();
        if (analyserRef.current) analyserRef.current.disconnect();
        audioContextRef.current.close();
        audioContextRef.current = null;
        track.current = null;
        analyserRef.current = null;
      }
    };
  }, [audioElement, showVideo]);

  return <canvas ref={canvasRef} width="150" height="150" />;
};

export default CircularWavePattern;
